<h2 mat-dialog-title>Añadir Nueva Sección</h2>

<mat-dialog-content>
  <p class="add-survey-section-dialog__subtitle">Selecciona el tipo de sección que deseas añadir</p>

  <div class="add-survey-section-dialog__options" role="list">
    @for (option of options; track option.type) {
      <button class="add-survey-section-dialog__option" type="button" role="listitem" (click)="selectOption(option.type)">
        <span class="add-survey-section-dialog__option-title">{{ option.title }}</span>
        <span class="add-survey-section-dialog__option-description">{{ option.description }}</span>
      </button>
    }
  </div>
</mat-dialog-content>
